import React from 'react';  
import { Link,withRouter } from 'react-router-dom';
import {permissionCheck} from './Permission';
import Nopermission from './Nopermission';
import Preloader from './Preloader';
import Pagination from 'react-js-pagination';
import Filter from './Filter'; 

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'',
                limit:10,
                page:1
            } 
        };
        this.fetchData = this.fetchData.bind(this); 
        this.filterSearch = this.filterSearch.bind(this);  
        this.PagenationChange = this.PagenationChange.bind(this);
        this.delete = this.delete.bind(this);
    }  

    delete(id){
        let del=window.confirm('Are you sure, do you want delete?');  
        if(del){
            this.props.delete(id);
        } 
    }
 
    PagenationChange(page) {
        this.setState({params:{...this.state.params,page}},()=>{
            this.fetchData();
        });
    }

    filterSearch(data){  
        let self = this;
        let search_term=data.search_term;
        let startDate=data.start;
        let endDate=data.end;
        let page=1;
        this.setState({params:{...self.state.params,search_term,startDate,endDate,page}},()=>{
            this.fetchData();
        });
    }
 
    fetchData(){
        this.props.handleFetch(this.state.params);
    }

    render() {
        const { data ,preloader,title,columns,primaryKey,addEditUrl,permission,CustomButton,backbtn } = this.props;
        let role=permissionCheck(permission); 
        if(!role)
            return <Nopermission/>;
        
        let action=role.permission?role.permission.split(','):[];
        let current_page=data.current_page?data.current_page:0;
        let per_page=data.per_page?data.per_page:0;
        let total=data.total?data.total:0; 

        let actionCheck= action.indexOf('Edit')>=0 || action.indexOf('Delete')>=0?true:false;

        return (
            <div id="page_content_inner">
                <h3 className="heading_b uk-margin-bottom">{title}</h3>
                <div className="md-card uk-margin-medium-bottom">
                    <Filter  
                        filterSearch={this.filterSearch.bind(this)}  
                        addbtn={action.indexOf('New')!==-1?addEditUrl:''}
                        backbtn={backbtn?backbtn:''}
                        props={this.props} 
                        {...this.props}
                        CustomButton={ action.indexOf('Download')!==-1?CustomButton:'' }
                    />
                    
                    <div className="uk-overflow-container">
                        <table className="uk-table  tablesorter-altair" style={{marginTop:'8px'}}>
                            <thead className="table-filter">
                                <tr>
                                    <th className="uk-text-center uk-text-bold">S.No</th>
                                    { 
                                        columns && columns.map((value,m)=>{
                                            return<th  key={m} className="uk-text-center uk-text-bold">{value.displayName}</th>;
                                        })
                                    }
                                    { actionCheck &&
                                    <th className="uk-text-center  uk-text-bold">Action</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.data && data.data.map((val,i)=>{ 
                                        let slno=(current_page-1)*per_page+i+1;
                                        return(
                                            <tr key={i} className={i%2===0?'even':'odd'}>
                                                <td className="uk-text-center">{slno}</td>
                                                { 
                                                    columns && columns.map((cols,km)=>{
                                                        const Cell=cols['Cell'];  
                                                        return <td key={km} style={cols.styles} className="uk-text-left">{Cell ? <Cell props={this.props} row={val} index={i} />:val[cols.key]}  </td>;  
                                                    })
                                                } 
                                                {
                                                    actionCheck &&
                                                 <td className="uk-text-center">  
                                                     { action.indexOf('Edit')!==-1 &&

                                                        <Link style={{verticalAlign:'-4px'}} to={`${addEditUrl}/${val[primaryKey]}`}><i className="md-icon material-icons">edit</i></Link>
                                                     }
                                                     {action.indexOf('Delete')!==-1 &&
                                                        <a onClick={(e)=>{
                                                            this.delete(val[primaryKey]);
                                                        }} ><i className="md-icon material-icons md-24" style={{color:'red'}}>&#xE872;</i></a>
                                                     }
                                             
                                                 </td>
                                                }
                                            </tr>
                                        );
                                    })
                                }
                                {
                                    data.data && data.data.length===0 &&
                            <tr>  
                                <td colSpan={columns.length+2} className="uk-text-center">No Record Found...!</td> 
                            </tr> 
                                }
                            </tbody>
                        </table> 

                        {
                            total>per_page &&
                                <Pagination
                                    activePage={current_page}
                                    itemsCountPerPage={per_page}
                                    totalItemsCount={total} 
                                    pageRangeDisplayed={5}
                                    onChange={this.PagenationChange} 
                                />
                        }
                        { preloader && <Preloader/> }
                    </div>
                </div>
            </div>

        );
    }
}

export default  withRouter(Table); 
 


// WEBPACK FOOTER //
// ./src/core/Table.js